var map = {
	"./IMG-20260225-WA0007.jpg.jpeg": 5575,
	"./IMG-20260225-WA0014.jpg.jpeg": 4519,
	"./IMG-20260225-WA0017.jpg.jpeg": 6859,
	"./IMG-20260225-WA0019.jpg.jpeg": 1197,
	"./IMG-20260225-WA0042.jpg.jpeg": 86,
	"./IMG-20260225-WA0045.jpg.jpeg": 2462,
	"./IMG-20260225-WA0070.jpg.jpeg": 4392,
	"./IMG-20260225-WA0079.jpg.jpeg": 6619,
	"./IMG-20260225-WA0080.jpg.jpeg": 1203,
	"./IMG-20260225-WA0090.jpg.jpeg": 8577,
	"./IMG-20260225-WA0092.jpg.jpeg": 7429,
	"./IMG-20260225-WA0093.jpg.jpeg": 398,
	"./IMG-20260225-WA0100.jpg.jpeg": 2189,
	"./IMG-20260225-WA0101.jpg.jpeg": 6033,
	"./IMG-20260225-WA0106.jpg.jpeg": 1298,
	"./IMG-20260225-WA0110.jpg.jpeg": 8769,
	"./IMG-20260225-WA0111.jpg.jpeg": 3717,
	"./IMG-20260225-WA0119.jpg.jpeg": 6629,
	"./IMG-20260225-WA0120.jpg.jpeg": 4654,
	"./IMG-20260225-WA0121.jpg.jpeg": 2086,
	"./IMG-20260225-WA0122.jpg.jpeg": 6131,
	"./IMG-20260225-WA0124.jpg.jpeg": 9593,
	"./IMG-20260225-WA0126.jpg.jpeg": 7408,
	"./image1.jpg": 8413,
	"./image2.jpg": 6310,
	"./image4.jpg": 4782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2040;